import React, { useEffect } from 'react';
import reactDom from 'react-dom';
import './Modal.scss';
import App from '../../../App';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import Timeline from '../../core/timeline/timeline';
function Modal(props) {
  const [portalTarget, setPortalTarget] = React.useState(null);
  const handleDismiss = () => {
    if (!props.disableDismiss) {
      props.showModal(false);
    }
  };

  useEffect(() => {
    if (props.noPortal) {
      setPortalTarget(null);
      return;
    }

    if (props.portalToBody) {
      setPortalTarget(document.body);
      return;
    }

    setPortalTarget(document.getElementById('fade'));
  }, [props.noPortal, props.portalToBody]);

  const modalContent = (
    <div
      className={`modal-wrap ${props.show ? 'show-me' : 'hide-me'} ${
        props.className || ''
      }`}
      style={props.style}
    >
      <div className='grey-cover' onClick={handleDismiss}></div>
      <div className='content-wrap'>
        <div>
          {!props.disableDismiss && (
            <button
              className='close'
              onClick={
                !props.overide ? () => props.showModal(false) : props.showModal
              }
            >
              <Close />
            </button>
          )}
          {props.children}
        </div>
      </div>
    </div>
  );

  if (props.noPortal) {
    return modalContent;
  }

  return portalTarget ? reactDom.createPortal(modalContent, portalTarget) : null;
}

export default Modal;
